export enum VagoAdditionalCoveragePerilNames {
  CRIME = 'Crime',
  LEGAL_SOLUTION = 'Legal Solution',
  EQUIPMENT_BREAKDOWN = 'Equipment Breakdown',
}

export const vagoAdditionalCoveragePerilNames = Object.values(
  VagoAdditionalCoveragePerilNames,
);
